export enum ConfigurationSortOptions {
  'SERVICE' = 'SERVICE',
}

export interface DashboardConfigurationFilterFormValues {
  microServiceName?: string;
  value?: string;
  hasError?: boolean;
}

export interface DashboardConfigurationFilter
  extends DashboardConfigurationFilterFormValues {
  search?: string;
}
